import { MdMarkEmailRead } from "react-icons/md";

export function EmptyNotifications() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            justifyContent: 'center',
        }}>
            <div className="mg-t-10"><MdMarkEmailRead size={32} /></div>
            <p className="mg-t-10 text-center">
                Você não tem nenhuma notificação nos últimos 30 dias.
            </p>
        </div >
    )
}